import { createContext, useContext } from "react"

import { ViewBarTabsContextValues } from "./ViewBarTabs.types"

export const ViewBarTabsContext = createContext<ViewBarTabsContextValues | undefined>(undefined)
ViewBarTabsContext.displayName = "ViewBarTabs"

export default function useViewBarTabs(): ViewBarTabsContextValues {
    const context = useContext(ViewBarTabsContext)
    if (!context) {
        throw new Error("useViewBarTabs must be used within a ViewBar.Tabs component")
    }
    return context
}
